import React from "react";
import { MenuItem } from "../../molecules";
import bellIcon from "../../../assets/images/bell-icon.svg";
import bellIconActive from "../../../assets/images/bell-icon-active.svg";
import deliveryIcon from "../../../assets/images/delivery-icon.svg";
import deliveryIconActive from "../../../assets/images/delivery-icon-active.svg";
import batIcon from "../../../assets/images/bat-icon.svg";
import batIconActive from "../../../assets/images/bat-icon-active.svg";
import shipmentIcon from "../../../assets/images/shipment-default.svg";
import shipmentIconActive from "../../../assets/images/shipment-active.svg";

export const SideMenu = ({
  onNewOrderClick,
  onProgressClick,
  onShipmentClick,
  onDeliveryClick,
  newOrderActive,
  onProgressActive,
  onShipmentActive,
  onDeliveryActive
}) => {

  return (
    <div className="menu-items-container">
      <MenuItem
        title="New Orders"
        icon={bellIcon}
        activeIcon={bellIconActive}
        onClick={onNewOrderClick}
        active={newOrderActive}
      />
      <MenuItem
        title="In Progress"
        icon={batIcon}
        activeIcon={batIconActive}
        onClick={onProgressClick}
        active={onProgressActive}
        id="progress-icon"
      />
      <MenuItem
        title="Ready for Shipment"
        icon={shipmentIcon}
        activeIcon={shipmentIconActive}
        onClick={onShipmentClick}
        active={onShipmentActive}
      />
      <MenuItem
        title="Out for Delivery"
        icon={deliveryIcon}
        activeIcon={deliveryIconActive}
        onClick={onDeliveryClick}
        active={onDeliveryActive}
        id="delivery-icon"
      />
    </div>
  );
};
